import auth0 from 'auth0-js';

const webAuth = new auth0.WebAuth({
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
  redirectUri: `${window.location.origin}/callback`,
  responseType: 'token id_token',
  scope: 'openid profile email',
  audience: process.env.REACT_APP_AUTH0_AUDIENCE
});

export default webAuth;
